<template>
    <div v-loading="loading">
        <el-radio-group v-model="assignType" @change="handleChange">
            <el-radio-button :label="0 + base">统一指派</el-radio-button>
            <el-radio-button :label="1 + base">分类型，尺寸指派</el-radio-button>
        </el-radio-group>
       <template v-if="assignType===0 + base">
            <p class="font12px mt10 mb10">说明：将选择的工单内所有任务的所有需求统一指派给下列选择的制作人。</p>
            <p class="text-color-error font12px mb10" v-if="assignDataInfo[assignType]?.num">可重新指派数量：{{ assignDataInfo[assignType].num }}</p>
            <FormItem ref="itemRef_0" :producer_options="producer_options" />
       </template>
       <template v-else-if="assignType === 1 + base">
            <p class="font12px mt20 mb20">说明：按照素材类型与尺寸，将所有还可以修改指派的需求分别统一修改给新的制作人。</p>
            <template v-for="(item, index) in assignDataInfo[assignType]">
                <div :key="index">
                    <el-divider><span  class="font12px title-label">{{typeNames[item.type] || '其它'}}</span></el-divider>
                    <div v-for="(subItem, subIndex) in item.list" class="form-card" :key="subIndex">
                        <div class="font12px tip">{{ subItem.material_resolution }}: 
                            <span class="text-color-error"> {{ assignType ===3 ?'可重新指派' :'需求' }} 数量：{{ subItem.num }}</span>
                        </div>
                        <FormItem 
                            :ref="`itemRef_${item.type}`" 
                            :producer_options="producer_options" 
                            :param="{ type: item.type, material_resolution: subItem.material_resolution }"
                        />
                    </div>
                </div>
            </template>
       </template>
        <p class="tac mt20 mb20">
            <el-button type="default" @click="hideBatchModal" class="mr20">取消</el-button>
            <el-button type="primary" @click="submitBatchModal" :loading="submitLoading" class="ml20">提交</el-button>
        </p>
    </div>
</template>

<script>
    import API from "@/api/workOrder/material";
    import {JtCascader } from '@/components/Ele';

    import FormItem from './formItem.vue';
    import _ from 'lodash'
    export default {
        name: "BatchAssignModal",
        props:['id', 'list','cbs', 'base'],
        components:{
            JtCascader,
            FormItem,
        },
        data(){
            const base = this.base;
            return {
                producer_options:[],  //制作人
                submitLoading:false,
                assignType: 0 + base,
                assignDataInfo:{},
                loading: false,
                typeNames: {
                    1: '图片',
                    2: '视频',
                }
            }
        },
        mounted(){
            console.log(this.id);
            this.fetchProducer();
            this.handleChange(this.assignType)
        },
        methods:{
            async handleChange(val) {
                if (!val) {
                    return;
                }
                if (!this.assignDataInfo[val]) {
                    this.loading = true;
                    const params = {
                        order_id: this.list.map(item=>item.order_id),
                        type: val
                    }
                    const { data } = await API.getWorkAssignOrderAllInfo(params);
                    this.assignDataInfo[val] = data;
                    this.loading = false;
                }
                
            },
            hideBatchModal(){
                this.$emit('close');
            },
            async submitBatchModal(){
                if (this.assignType === 0 + this.base) {
                    const formData = await this.$refs.itemRef_0.getFormData();
                    console.log(formData,this.id);
                    // this.cbs.onSubmit(batchSearch);
                    try {
                        this.submitLoading = true;
                        if (this.assignType === 0) {
                            await API.postAssignOrderAll({
                                order_id:this.id,
                                set_date_type: formData.set_date_type,
                                finish_time: formData.finish_time,
                                producer_uids:formData.producer_uids,
                            })
                        }else {
                            await API.postRedoAssignOrderAll({
                                order_id: this.list.map(v=>v.order_id),
                                set_date_type: formData.set_date_type,
                                finish_time: formData.finish_time,
                                producer_uids:formData.producer_uids,
                            })
                        }
                        this.$message.success('操作成功');
                        this.cbs.onSubmit();
                        this.$emit('close');
                    } catch (error) {
                        this.$message.error(error.info)
                    } finally {
                         this.submitLoading = false
                    }
                }else if(this.assignType === 1 + this.base){
                    // 异步遍历
                    const formDataList = await Promise.all(this.assignDataInfo[this.assignType].reduce( (acc,item)=>{
                        this.$refs[`itemRef_${item.type}`].forEach(ref=>{
                            acc.push(ref.getFormData());
                        })
                        return acc;
                    },[]));
                    try {
                        this.submitLoading = true
                        const params = {
                            order_id: this.list.map(v=>v.order_id),
                            details: formDataList
                        }
                        if(this.assignType === 1) {
                            await API.postAssignOrderByMaterial(params);
                        }else {
                            await API.postRedoAssignOrderAllByMaterial(params);
                        }
                        
                        this.$message.success('操作成功');
                        this.cbs.onSubmit();
                        this.$emit('close');
                    } catch (error) {
                        this.$message.error(error.info)
                    }finally {
                        this.submitLoading = false
                    }
                }
            },
            hideSubmitLoading(){
                // this.submitLoading = false;
            },
            fetchProducer() {
                API.getAssignOrderProducer().then(res=>{
                    this.producer_options = this.modifyIdsToValues(res.data)
                },err=>{
                    this.$message.error(err.info)
                })
            },
            
            modifyIdsToValues(arr) {
                return arr.map(obj => {
                    const newObj = { ...obj };
                    if (newObj.children && newObj.children.length > 0) {
                        newObj.children = this.modifyIdsToValues(newObj.children);
                    }
                    if (newObj.hasOwnProperty('id')) {
                        newObj.value = newObj.id
                        newObj.label = newObj.name
                        // newObj.disabled = newObj.user_status == 0 ? true : false
                        delete newObj.id
                        delete newObj.name
                        // delete newObj.user_status
                    }

                    return newObj;
                });
            },
        },
    }
</script>

<style lang="scss" scoped>

.form-card {
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 12px;
    .tip {
        padding-left: 30px;
        margin-bottom: 12px;
    }
}
</style>
